import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../text-input/TextInput';
import CheckboxInput from '../checkbox-input/CheckboxInput';
import './ImageInput.css';

export default class ImageInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      existingContentObject: (this.props.existingContentObject) ? this.props.existingContentObject : {}
    };
  }
  
  componentWillReceiveProps(newProps) {
    // For case where user is going from edit-mode to read-only-mode (like onCancel)
    if ( 
      newProps.existingContentObject !== this.props.existingContentObject && 
      this.props.isEditable && 
      !newProps.isEditable
    ) {
      this.setState({ existingContentObject: newProps.existingContentObject });
    }
  }
  
  // Grabs the values from the inputs and updates the state with the new values
  getValue = () => {
    if (this.props.isEditable) {
      let newImageObject = {}; 

      newImageObject["imageURL"] = this[`${this.props.id}__image-URL`].getValue();
      newImageObject["imageCaption"] = this[`${this.props.id}__image-caption`].getValue();
      newImageObject["imageAlt"] = this[`${this.props.id}__image-alt`].getValue();
      
      if (this.props.hasGraphicCheckbox) {
        newImageObject["imageIsGraphic"] = this[`${this.props.id}__image-graphic`].getValue();
      }

      this.setState({ existingContentObject: newImageObject });

      return newImageObject;
    }
  
    return this.state.existingContentObject;  
  }

  render () {  
    const label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;
    
    const graphicCheckbox = (this.props.hasGraphicCheckbox) ?
      <CheckboxInput
        id={`${this.props.id}__image-graphic`}
        label="Graphic Image"
        checked={this.state.existingContentObject["imageIsGraphic"]}
        isEditable={(!this.props.isEditable) ? false : undefined}
        ref={instance => { this[`${this.props.id}__image-graphic`] = instance; }}
      /> :
      null;
    
    // Shows inputs when in edit mode, and read only versions of inputs if showInputsInReadOnly is true
    let inputDisplay = (this.props.isEditable || this.props.showInputsInReadOnly) ?
      <span>
        <TextInput 
          id={`${this.props.id}__image-URL`}
          label="URL"
          className="field__large"
          disabled={this.props.disabled}
          existingContent={this.state.existingContentObject["imageURL"]}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onChange={this.getValue}
          ref={instance => { this[`${this.props.id}__image-URL`] = instance; }}
        />
        <TextInput 
          id={`${this.props.id}__image-caption`}
          label="Caption"
          className="field__large"
          disabled={this.props.disabled}
          existingContent={this.state.existingContentObject["imageCaption"]}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onChange={this.getValue}
          ref={instance => { this[`${this.props.id}__image-caption`] = instance; }}
        />
        <TextInput 
          id={`${this.props.id}__image-alt`}
          label="Alt Text"
          className="field__large"
          disabled={this.props.disabled}
          existingContent={this.state.existingContentObject["imageAlt"]}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onChange={this.getValue}
          ref={instance => { this[`${this.props.id}__image-alt`] = instance; }}
        />
        {graphicCheckbox}
      </span> :
      null;
    
    // Only shows image content when a URL is provided
    let imageDisplay = (this.state.existingContentObject && this.state.existingContentObject["imageURL"]) ?
      <div>
        <img 
          src={this.state.existingContentObject["imageURL"]}
          alt={this.state.existingContentObject["imageAlt"]}
        />
        <div className="image-input__caption">{this.state.existingContentObject["imageCaption"]}</div>
      </div> :
      null;

    return (
      <div className="image-input field">
        {label}
        {imageDisplay}
        {inputDisplay}
      </div>
    );
  }
}
    
ImageInput.defaultProps = {
  hasGraphicCheckbox: false,
  isEditable: true,
  showInputsInReadOnly: false
};

ImageInput.propTypes = {
  disabled: PropTypes.bool,
  existingContentObject: PropTypes.shape({
    imageAlt: PropTypes.string,
    imageCaption: PropTypes.string,
    imageIsGraphic: PropTypes.bool,
    imageURL: PropTypes.string
  }),
  hasGraphicCheckbox: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  showInputsInReadOnly: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/shared/components/presentation/image-input/ImageInput.js